import { apiClient } from "./api";

export const listFiles = async (userId) => {
  const sessionToken = sessionStorage.getItem("session_token");

  if (!userId) {
    console.warn("listFiles called without userId; skipping fetch.");
    return { files: [] };
  }

  const response = await apiClient.get(
    `/api/storage/list?userId=${userId}&session_token=${sessionToken}`
  );

  return response.data;
};

export const getFile = async (datasetId, userId) => {
  const sessionToken = sessionStorage.getItem("session_token");

  const response = await apiClient.get(
    `/api/storage/file?datasetId=${datasetId}&userId=${userId}&session_token=${sessionToken}`
  );

  return response.data;
};

export const uploadFile = async (content, fileName, userId) => {
  const sessionToken = sessionStorage.getItem("session_token");

  const response = await apiClient.post("/api/storage/upload", {
    content,
    fileName,
    userId: parseInt(userId),
    session_token: sessionToken,
  });

  return response.data;
};

export const loadHuggingFaceDataset = async (
  datasetUrl,
  userId,
  sampleSize = 1000
) => {
  const sessionToken = sessionStorage.getItem("session_token");

  const response = await apiClient.post("/api/storage/huggingface", {
    datasetUrl,
    userId: parseInt(userId),
    session_token: sessionToken,
    sampleSize,
  });

  return response.data;
};

export const deleteDataset = async (datasetId, userId) => {
  const sessionToken = sessionStorage.getItem("session_token");

  await apiClient.delete(
    `/api/storage/datasets/${datasetId}?userId=${userId}&session_token=${sessionToken}`
  );
};